exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-weight-bold[data-v-613b1e29] {\n  font-weight: 700;\n}", ""]);

// exports
